import { render, staticRenderFns } from "./ChatGenesys.vue?vue&type=template&id=36a05516"
import script from "./ChatGenesys.vue?vue&type=script&lang=js"
export * from "./ChatGenesys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports